(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-contact"] && !Shopify.designMode) return;
  try {
    
  (function(){var ok=document.getElementById('lp-contact-ok');if(ok){ok.scrollIntoView({block:'center'});ok.focus({preventScroll:true});}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-produit-tete"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lp-car]').forEach(function(car){
    var piste=car.querySelector('[data-lp-piste]'); if(!piste) return;
    var slides=piste.querySelectorAll('[data-lp-slide]');
    var vignettes=car.querySelectorAll('[data-lp-go]');
    function aller(i){ i=Math.max(0,Math.min(slides.length-1,i)); piste.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'}); }
    function courant(){ return Math.round(piste.scrollLeft/piste.clientWidth); }
    var p=car.querySelector('[data-lp-prev]'), n=car.querySelector('[data-lp-next]');
    if(p) p.addEventListener('click',function(){aller(courant()-1)});
    if(n) n.addEventListener('click',function(){aller(courant()+1)});
    vignettes.forEach(function(b){b.addEventListener('click',function(){aller(parseInt(b.getAttribute('data-lp-go'),10))})});
    var t; piste.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var c=courant();vignettes.forEach(function(b,i){if(i===c)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')})},80)});
  });
  var sel=document.querySelector('[data-lp-variant]');
  if(sel){ sel.addEventListener('change',function(){ var o=sel.options[sel.selectedIndex]; var prix=document.querySelector('[data-lp-prix]'); if(prix&&o.dataset.prix) prix.textContent=o.dataset.prix; var b=document.querySelector('[data-lp-ajouter]'); if(b){ var ok=o.dataset.dispo==='true'; b.disabled=!ok; b.textContent=ok?'{{ section.settings.bouton }}':'Épuisé'; } }); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
